










































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import consts from "../consts";
import axios from "axios";
import { User, UserStat, Rubric } from "../types";

@Component
export default class Feedback extends Vue {
  @Prop() private JWT!: string;
  @Prop() private localJWT!: string;
  @Prop() private teamID!: string;
  @Prop() private userID!: string;
  @Prop() private sessionID!: string;
  @Prop() private currentTeamUsers!: User[];
  @Prop() private currUser!: User;
  @Prop() private viewOnly!: boolean;
  @Prop() private shareOnly!: boolean;

  private rubricScore: any = { Score: 0, Total: 0 };
  private showFeedback: boolean = true;
  private rubricData: Rubric | null = null;
  private completedRubrics: any[] = [];
  private currRubric: number = 0;
  private rubricSubmitted: boolean = false;

  private error: boolean = false; // API error
  private errorMsg: string = "Something went wrong.";

  private created() {
    this.fetchData();
  }

  get isRubricDisabled() {
    
    if(this.rubricData) {
      
      let selectedAnswers = this.rubricData.questions.filter((question: any) => {
        return !isNaN(question.selectedAnswer);
      });

      return selectedAnswers.length !== this.rubricData.questions.length;
    }
    return true;
  }

  private fetchData() {
    console.log(
      "FETCH",
      this.viewOnly,
      this.localJWT,
      this.sessionID,
      this.currentTeamUsers
    );
    if (this.viewOnly) {
      if (this.shareOnly) {
      } else {
        if (this.localJWT) {
          this.rubricData = null;
          this.fetchCompletedRubrics(this.sessionID);
        }
      }
    } else {
      if (this.sessionID && this.currentTeamUsers) {
        this.fetchCompletedRubrics(this.sessionID);
      }
    }
  }

  private getRubricUserName(i: number) {
    if (this.completedRubrics.length > i) {
      let uid = this.completedRubrics[i].sessionAnswers[0].answeredBy;
      return uid;
    }
  }

  private getRubricScore() {
    // let scoredata = [];
    let total = 0;
    let score = 0;
    if (this.rubricSubmitted && this.rubricData) {
      let scoredata = this.rubricData.questions.map((ques: any) => {
        return {
          length: ques.answers.length,
          answer: ques.answers[ques.selectedAnswer].displayOrder
        };
      });
      total = scoredata.reduce(
        (partialSum: number, a: any) => partialSum + a.length,
        0
      );
      score = scoredata.reduce(
        (partialSum: number, a: any) => partialSum + a.answer,
        0
      );
    } else if (this.rubricData) {
      let scoredata = this.rubricData.questions.map((ques: any) => {
        let answer = 0;
        if (ques.selectedAnswer !== undefined && ques.selectedAnswer !== null) {
          answer = ques.selectedAnswer + 1;
        }
        return {
          length: ques.answers.length,
          answer
        };
      });
      total = scoredata.reduce(
        (partialSum: number, a: any) => partialSum + a.length,
        0
      );
      score = scoredata.reduce(
        (partialSum: number, a: any) => partialSum + a.answer,
        0
      );
    }

    return { Total: total, Score: score };
  }

  private radioChange(i: number, j: number) {
    // console.log(this.rubricData!.questions[0].selectedAnswer);
    //   console.log(this.rubricData!.questions[1].selectedAnswer);
    //   console.log(this.rubricData!.questions[2].selectedAnswer);
    //   console.log(this.rubricData);
    // console.log(i + " : " + j);
    // setTimeout(this.foo,1000);

    this.rubricScore = this.getRubricScore();
  }

  private rubricToAnswers(rubric: Rubric | null): any {
    let sessionAnswers = {
      sessionAnswers: [] as any[]
    };

    for (let i = 0; i < rubric!.questions.length; ++i) {
      let question = rubric!.questions[i];
      let answer = 0;
      if (question.selectedAnswer === undefined) {
        return null;
      } else {
        console.log(question.selectedAnswer);
        console.log(question.answers);
        answer = question.answers[question.selectedAnswer].displayOrder;
      }

      sessionAnswers.sessionAnswers.push({
        question: { displayOrder: question.displayOrder as number },
        answer: { displayOrder: answer as number }
      });
    }
    return sessionAnswers;
  }

  private submitRubric() {
    let rubric = this.rubricData;
    let sessionAnswers: any | null = this.rubricToAnswers(rubric);
    if (sessionAnswers) {
      this.rubricSubmitted = true;
      axios({
        method: "POST",
        url: `${consts.serverURL}rubric/session/${rubric!.rubricSlug}/${
          rubric!.version
        }/${this.sessionID}`,
        headers: { Authentication: this.JWT },
        data: sessionAnswers
      })
        .then(resp => {
          console.log("SUBMIT RUBRIC", resp);
        })
        .catch(reason => {
          console.log(reason, reason.response);
          this.rubricSubmitted = false;
        });
    }
  }

  private fetchRubrics() {
    if (this.teamID) {
      let jwt = this.viewOnly ? this.localJWT : this.JWT;
      axios
        .get(consts.serverURL + "rubric/default/" + this.teamID, {
          headers: { Authentication: jwt }
        })
        .then(resp => {
          console.log("DEFAULT RUBRIC", resp.data);
          this.rubricData = resp.data as Rubric;
          this.rubricScore = this.getRubricScore();
        })
        .catch(reason => {
          console.log(reason, reason.response);
          this.error = true;
          this.errorMsg = reason.response.data.Error;
        });
    }
  }

  private fetchCompletedRubrics(sessionID: string) {
    console.log("FETCH COMPLETED RUBS");
    let jwt = this.viewOnly ? this.localJWT : this.JWT;
    axios
      .get(consts.serverURL + "rubric/session/" + this.sessionID, {
        headers: { Authentication: jwt }
      })
      .then(resp => {
        console.log("COMPLETED RUBRICS", resp.data);
        this.completedRubrics = resp.data;
        let len = this.completedRubrics.length;
        if (len) {
          for (let i = 0; i < len; ++i) {
            let rubric = this.completedRubrics[i].rubric;
            let sessionAnswers = this.completedRubrics[i].sessionAnswers;
            if (
              rubric &&
              rubric.questions &&
              rubric.questions.length &&
              sessionAnswers &&
              sessionAnswers.length &&
              sessionAnswers.length === rubric.questions.length
            ) {
              for (let j = 0; j < rubric.questions.length; ++j) {
                let selectedAnswer = sessionAnswers[j].answer.displayOrder;
                let answers = rubric.questions[j].answers;
                // Check if manager has already submitted rubric
                // if (sessionAnswers[j].answeredBy === this.currUser.UID) {
                this.rubricSubmitted = true;
                // }

                // Get selectedAnswer
                for (let k = 0; k < answers.length; ++k) {
                  if (selectedAnswer === answers[k].displayOrder) {
                    rubric.questions[j].selectedAnswer = k;
                    break;
                  }
                }
              }
            }
          }
          this.currRubric = len - 1;
          this.rubricData = this.completedRubrics[this.currRubric].rubric;
          this.rubricScore = this.getRubricScore();
        }
      })
      .catch(reason => {
        console.log(reason, reason.response);
        if (this.viewOnly) {
          this.error = true;
          this.errorMsg = "No Completed Rubrics";
        } else {
          this.fetchRubrics();
          this.showFeedback = true;
        }
      });
  }

  private changeRubric(i: number) {
    this.currRubric = i;
    this.rubricData = this.completedRubrics[i].rubric;
  }

  @Watch("sessionID")
  private onSessionIDChanged(newVal: any, oldVal: any) {
    if (newVal && newVal !== oldVal) {
      this.fetchData();
    }
  }
}
